import { useState } from "react";
import { toast } from "sonner";
import { MailWarning, Loader2 } from "lucide-react";
import { publicApi, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { _t } from "@/lib/i18n";

export const ResendVerificationButton = ({ email }) => {
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await publicApi.post("/auth/resend-verification", { email });
      setSent(true);
      toast.success(_t("Ti abbiamo inviato un nuovo link di conferma. Controlla anche lo Spam."));
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <button data-testid="resend-verification-btn" onClick={send} disabled={busy || sent} className="btn-primary inline-flex items-center gap-2">
      {busy && <Loader2 className="w-4 h-4 animate-spin" />}
      {sent ? _t("Link inviato") : _t("Invia di nuovo il link")}
    </button>
  );
};

export const VerifyEmailBanner = () => {
  const { user } = useAuth();
  if (!user || user.is_admin || user.email_verified) return null;
  return (
    <div data-testid="verify-email-banner" className="border-b border-amber-400/30 bg-amber-400/10">
      <div className="max-w-7xl mx-auto px-6 py-3 flex flex-wrap items-center gap-3 text-sm text-amber-100">
        <MailWarning className="w-5 h-5 text-amber-400 shrink-0" />
        <span className="flex-1 min-w-[14rem]">
          {_t("Conferma la tua email per creare capsule: apri il link che ti abbiamo inviato a")} <b>{user.email}</b>.
        </span>
        <ResendVerificationButton email={user.email} />
      </div>
    </div>
  );
};
